import clsx from 'clsx';
import React from 'react';

import Button, { ButtonProps } from '@components/Button';

export type DefaultSubmenuNavItemProps = ButtonProps & {
  description?: string;
};

const DefaultSubmenuNavItem = ({ className, description, ...rest }: DefaultSubmenuNavItemProps) => (
  <li>
    <Button
      className={clsx(
        'border-none bg-transparent font-suisse-neue text-body-md text-white transition-colors hover:text-primary-magenta focus:text-primary-magenta',
        className
      )}
      {...rest}
    />
    {description && (
      <p className="m-0 font-suisse-screen text-disclosure-md leading-[1.3] text-white">
        {description}
      </p>
    )}
  </li>
);

export default DefaultSubmenuNavItem;
